import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Category, Restaurant, ShoppingCart } from '../restaurant-manager.models';
import { Observable } from 'rxjs';
import { RestaurantService } from './restaurant.service';
import { ApiService } from './api.service';
import { MenuDataInterface } from './sync.service';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {
    private shoppingCart: ShoppingCart = null;

    constructor(private apiService: ApiService, private restaurantService: RestaurantService) { }

    list(): Observable<Category[]> {
        return this.apiService.get<Category[]>('/restaurants/' + this.restaurantService.selectedRestaurant.value.id + '/products', false).pipe(map((categories: any[]) => {
            return categories.map(c => new Category(c));
        }));
    }

    first(): Observable<Category> {
        return this.apiService.get<Category>('/restaurants/' + this.restaurantService.selectedRestaurant.value.id + '/product-categories/first', false).pipe(map((category) => {
            return new Category(category);
        }));
    }

    buildCategoriesFromMenuData(data: MenuDataInterface, restaurant: Restaurant): Category[] {
        const categories = data.categories as Category[];
        for (let c of categories) {
            const menus = data.menus?.filter(m => m.category === c.id);
            const products = data.products?.filter(p => p.category === c.id);
            const lightRestaurant = new Restaurant({
                id: restaurant.id
            });
            if (menus?.length > 0) {
                c.menus = menus;
            }
            if (products?.length > 0) {
                c.products = products;
                for (let i of c.ingredients) {
                    i.stocks = data.stocks.filter((s: any) => s.entity === i.id);
                    for (let s of i.stocks) {
                        s.restaurant = lightRestaurant;
                    }
                }
                for (let p of c.products) {
                    p.choiceGroups = data.choices.filter((c: any) => c.product === p.id);
                    p.stocks = data.stocks.filter((s: any) => s.entity === p.id);
                    for (let s of p.stocks) {
                        s.restaurant = lightRestaurant;
                    }
                    for (let i of p.ingredients) {
                        i.stocks = data.stocks.filter((s: any) => s.entity === i.id);
                        for (let s of i.stocks) {
                            s.restaurant = lightRestaurant;
                        }
                    }
                    for (let cg of p.choiceGroups) {
                        for (let c of cg.choices) {
                            c.stocks = data.stocks.filter((s: any) => s.entity === c.id);
                            for (let s of c.stocks) {
                                s.restaurant = lightRestaurant;
                            }
                            if (c.ingredient) {
                                c.ingredient.stocks = data.stocks.filter((s: any) => s.entity === c.ingredient.id);
                                for (let s of c.ingredient.stocks) {
                                    s.restaurant = lightRestaurant;
                                }
                            }
                        }
                    }

                }
            }
        }
        return categories.map(c => new Category(c)).filter(c => c.products?.length > 0 || c.menus?.length > 0 || c.canCreateProductOnPos);
    }

}
